import { Col, Image, Row } from 'antd'
import moment from 'moment'
import './GeneralInformationTJXFinal.style.less'
import { isEmptyValue } from '@/utils/common'
import { isArray, orderBy, startCase } from 'lodash'
import { formatDeliveryDate } from '@/utils/date'
import { DATE_FORMAT } from '@/constant/date'

interface Props {
  data: any
  dataSetting: any
}

function GeneralInformationTJXFinal(props: Props) {
  const data = props.data?.generalInformation

  const customFieldName = (data: any) => {
    const field_names = !isEmptyValue(props.dataSetting)
      ? props.dataSetting[0]?.value?.field_names
      : []
    return (
      field_names?.find((item) => item?.field === data?.field)?.display_name ??
      startCase(data?.name)
    )
  }

  const leftFields = [
    {
      name: 'Inspection Date',
      field: 'inspectionDate',
      value: moment(data.inspectionDate).format(DATE_FORMAT.DDMMYY),
    },
    {
      name: 'Buyer',
      field: 'buyer',
      value: data?.buyer,
    },
    {
      name: 'Inspection Type',
      field: 'inspectionType',
      value: data?.inspectionType,
    },
    { name: 'Order No', field: 'number', value: data?.orderNumber },
    {
      name: 'Inspection No',
      field: 'inspectionNumber',
      value: data?.inspectionNumber,
    },
    {
      name: 'Style ID',
      field: 'styleId',
      value: data?.styleID,
    },
    {
      name: 'Inspector Name',
      field: 'inspectorName',
      value: data?.inspectorName,
    },
    {
      name: 'Product Category',
      field: 'productCategory',
      value: data?.productCategory,
    },
    {
      name: 'Inspection AQL',
      field: 'inspectionAQL',
      value: data?.inspectionAQL,
    },
    {
      name: 'Delivery Date',
      field: 'deliveryDate',
      value: formatDeliveryDate(data.deliveryDate),
    },
    {
      name: 'Order Quantity',
      field: 'orderQuantity',
      value: data?.orderQuantity,
    },
    {
      name: 'Supplier',
      field: 'supplier',
      value: data?.supplier,
    },
    {
      name: 'Available Quantity',
      field: 'availableQty',
      value: data?.availableQty,
    },
    {
      name: 'Factory',
      field: 'factory',
      value: data?.factory,
    },
    {
      name: 'Sample Size',
      field: 'sampleSize',
      value: data?.sampleSize,
    },
    {
      name: 'Production Country',
      field: 'country',
      value: data?.productionCountry,
    },
  ]

  const customFiveField = [
    {
      name: 'Inspection Date',
      field: 'inspectionDate',
      value: moment(data.inspectionDate).format(DATE_FORMAT.DDMMYY),
    },
    {
      name: 'Inspection Type',
      field: 'inspectionType',
      value: data?.inspectionType,
    },
    {
      name: 'Inspection No',
      field: 'inspectionNumber',
      value: data?.inspectionNumber,
    },
    {
      name: 'Factory',
      field: 'factory',
      value: data?.factory,
    },
    {
      name: 'Vendor',
      field: 'supplier',
      value: data?.supplier,
    },
  ]

  const orderImage = () => {
    if (!isEmptyValue(props.data?.order))
      return props.data?.order?.picture?.url_path
    return props.data?.orders[0]?.picture?.url_path
  }
  const supplierCode = () => {
    if (!isEmptyValue(props.data?.order))
      return props.data?.order?.supplier?.code
    return props.data?.orders[0]?.supplier?.code
  }

  const factoryCode = () => {
    if (!isEmptyValue(props.data?.order))
      return props.data?.order?.factory?.code
    return props.data?.orders[0]?.factory?.code
  }

  const dataCustoms = orderBy(
    props.data?.generalInformationCustom,
    'display_order',
    'desc'
  )?.map((item) => {
    return {
      name: item?.key,
      field: item?.key,
      value:
        item?.key == 'supplierCode'
          ? supplierCode()
          : item?.key == 'factoryCode'
          ? factoryCode()
          : isArray(item?.value)
          ? item?.value
              ?.map((tmp) => {
                return tmp
              })
              .join(', ')
          : item?.data_type == 'date'
          ? formatDeliveryDate(item.value)
          : item.value,
    }
  })

  return (
    <div className="general-information-container">
      <p className="title">General Information</p>
      <div style={{ display: 'flex' }}>
        {!isEmptyValue(customFiveField) ? (
          <div className="data-container" style={{ flex: 5 }}>
            <Row>
              {customFiveField.map((item: any) => {
                return (
                  <Col
                    style={{
                      flexDirection: 'row',
                      display: 'flex',
                      marginTop: 6,
                    }}
                    key={item.field}
                    span={24}
                  >
                    <p className="label">{customFieldName(item)}:</p>
                    <p className="value">{item?.value}</p>
                  </Col>
                )
              })}
            </Row>
          </div>
        ) : (
          <div className="data-container" style={{ flex: 5 }}>
            <Row>
              {customFiveField.map((item: any) => {
                return (
                  <Col
                    style={{
                      flexDirection: 'row',
                      display: 'flex',
                      marginTop: 6,
                    }}
                    key={item.field}
                    span={24}
                  >
                    <p className="label">{customFieldName(item)}:</p>
                    <p className="value">{item?.value}</p>
                  </Col>
                )
              })}
            </Row>
          </div>
        )}
        <div className="photo-container">
          <Image src={orderImage()} />
        </div>
      </div>
    </div>
  )
}

export default GeneralInformationTJXFinal
